const PurchaseTag = (props) => (
  <svg width='19.458' height='19.458' viewBox='0 0 19.458 19.458' fill='#fff' {...props}>
    <path d='M10.752.595A2.024,2.024,0,0,0,10.1.155,1.979,1.979,0,0,0,9.325,0H2.046A1.974,1.974,0,0,0,.595.595,1.974,1.974,0,0,0,0,2.046V9.325a1.979,1.979,0,0,0,.155.773,2.024,2.024,0,0,0,.44.654L8.73,18.863a2.01,2.01,0,0,0,2.854,0l7.279-7.279a2.01,2.01,0,0,0,0-2.854ZM5.09,7.112a1.974,1.974,0,0,1-1.451-.595A1.946,1.946,0,0,1,3.045,5.09,2.031,2.031,0,0,1,5.09,3.045a1.946,1.946,0,0,1,1.427.595A1.974,1.974,0,0,1,7.112,5.09,2.03,2.03,0,0,1,5.09,7.112Z' />
  </svg>
)

export default PurchaseTag
